import React from "react";
import { LargeVolumeDeliveryEditor } from "../features/large-volume-delivery";
import { withRestaurantId } from "../shared/components/layout";

const LargeVolumeDeliveryEditorWithId = withRestaurantId(LargeVolumeDeliveryEditor);

const LargeVolumeDeliveryPage: React.FC = () => {
  return <LargeVolumeDeliveryEditorWithId />;
};

export default LargeVolumeDeliveryPage;
